<div class="Customers customer-company ui-g">
  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
      <div>
        <div class="ui-g ui-g-nopad form-group master-data">
          <div class="ui-g-8 ui-g-nopad">
            <h1 class="step-title">{{ this.pageTitle | translate }}</h1>
          </div>

          <div class="ui-g-12 ui-lg-2 text-right">
            <button pButton type="button" class="k-generic-btn" icon="fa fa-floppy-o" iconPos="left" label="{{ 'common.save' | translate }}" (click)="save()"></button>
          </div>
        </div>
      </div>

      <div class="card">
        <form [formGroup]="formData" *ngIf="formData">
          <div class="ui-g form-group master-data">
            <div [kv-form-element]="{ label: 'card.card_no', md: '4', required: checkIfRequired('cardNo') }">
              <input type="text" pInputText formControlName="cardNo" />
            </div>

            <div [kv-form-element]="{ label: 'customerDetail.surname', md: '4', required: checkIfRequired('surname') }">
              <input type="text" pInputText formControlName="surname" />
            </div>

            <div [kv-form-element]="{ label: 'customerDetail.name', md: '4', required: checkIfRequired('name') }">
              <input type="text" pInputText formControlName="name" />
            </div>

            <div [kv-form-element]="{ label: 'customerDetail.mail_1', md: '4', required: checkIfRequired('email') }">
              <input type="text" pInputText formControlName="email" />
            </div>

            <div [kv-form-element]="{ label: 'customerDetail.phone', md: '4', required: checkIfRequired('telephone') }">
              <input type="text" pInputText formControlName="telephone" />
            </div>

            <div [kv-form-element]="{ label: 'customerDetail.sex', md: '4', required: checkIfRequired('sex') }">
              <p-dropdown [options]="sessi" formControlName="sex"></p-dropdown>
            </div>

            <div [kv-form-element]="{ label: 'customerInfoSheet.birthdayDate', md: '3', required: checkIfRequired('birthDate') }">
              <app-kv-calendar
              #birthDateSelector
              [inputName]="'birthDate'"
              [yearRange]="'1900:2020'"
              [defaultDate]="maxDate"
              [maxDate]="maxDate"
              [formData]="formData"
              ></app-kv-calendar>
            </div>

            <div [kv-form-element]="{ label: 'customerDetail.address_venue', md: '7', required: checkIfRequired('address1') }">
              <input type="text" pInputText formControlName="address1">
            </div>

            <div [kv-form-element]="{ label: 'customerDetail.number', md: '2', required: checkIfRequired('addressNumber') }">
              <input type="text" pInputText formControlName="addressNumber">
            </div>

            <div [kv-form-element]="{ label: 'customerDetail.zip', md: '3', required: checkIfRequired('zipCode') }">
              <input type="text" pInputText formControlName="zipCode">
            </div>

            <div [kv-form-element]="{ label: 'customerDetail.city', md: '4', required: checkIfRequired('city') }">
              <input type="text" pInputText formControlName="city">
            </div>

            <div class="ui-g-12">
              <hr />
            </div>
        </div>

          <div class="ui-g form-group master-data">
            <div [kv-form-element]="{ label: 'customerDetail.authorizations', md: '12' }"></div>

            <div [kv-form-element]="{ label: 'customerDetail.authorization_sendname', md: '6', required: checkIfRequired('privacyTerminal') }">
              <p-inputSwitch formControlName="privacyTerminal"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_generalcommunications', md: '6', required: checkIfRequired('privacyGenericComm') }">
              <p-inputSwitch formControlName="privacyGenericComm"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_marketingresearch', md: '6', required: checkIfRequired('privacyMktgResearch') }">
              <p-inputSwitch formControlName="privacyMktgResearch"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_privacy', md: '6', required: checkIfRequired('privacyAuth') }">
              <p-inputSwitch formControlName="privacyAuth"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_profiling', md: '6', required: checkIfRequired('privacyMktgProfiling') }">
              <p-inputSwitch formControlName="privacyMktgProfiling"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_marketingactivity', md: '6', required: checkIfRequired('privacyMktgActivity') }">
              <p-inputSwitch formControlName="privacyMktgActivity"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_purchasecommunications', md: '6', required: checkIfRequired('privacyPurchaseCom') }">
              <p-inputSwitch formControlName="privacyPurchaseCom"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_push', md: '6', required: checkIfRequired('privacyOptin') }">
              <p-inputSwitch formControlName="privacyOptin"></p-inputSwitch>
            </div>
          </div>
      </form>
      </div>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-ext/create-customer-ext/create-customer-ext.component.html